export default {"src":"/_next/static/media/FOUR.7fae5f51.svg","height":18,"width":18};